import { render, staticRenderFns } from "./BonusReportFilters.vue?vue&type=template&id=45a9562a&"
import script from "./BonusReportFilters.vue?vue&type=script&lang=js&"
export * from "./BonusReportFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports